import { gql } from '@apollo/client';

export const DELETE_USER = gql`
  mutation deleteUser($userUUID: String!) {
    deleteUser(userUUID: $userUUID) {
      uuid
      firstName
      lastName
      email
      roles
      paymentMethod
      status
      dayOfBirth
      createdAt
      mobile {
        uuid
        countryCode
        localNumber
        isVerified
      }
      home {
        uuid
        addressLine1
        addressLine2
        zip
        country
        state
      }
      idologyLogs {
        uuid
        idNumber
        requestResponse
        status
      }
    }
  }
`;
